import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { Roles } from "../../utils/role";

export interface UserState {
  _id?: string;
  zohoCustomerId: string;
  firstName: string;
  lastName: string;
  steps?: string;
  role: string;
  solarStudyInvite?: boolean;
  contactOwnerUserId: string;
  Contact_Group?: string;
  email?: string;
  purlDocuments?: boolean;
}

const storedUser = localStorage.getItem("user");
let parsedUser: UserState | null = null;
try {
  parsedUser = storedUser ? JSON.parse(storedUser) : null;
} catch (error) {
  console.error("Error parsing user data from localStorage:", error);
}

const initialState: UserState = parsedUser || {
  _id: "",
  zohoCustomerId: "",
  firstName: "",
  lastName: "",
  steps: "",
  role: Roles.CUSTOMER,
  solarStudyInvite: false,
  contactOwnerUserId: "",
  Contact_Group: "",
  email: "",
  purlDocuments: false
};

export const loginSlice = createSlice({
  name: "userLogin",
  initialState,
  reducers: {
    setUserLogin: (state, action: PayloadAction<UserState>) => {
      state._id = action.payload._id || "";
      state.zohoCustomerId = action.payload.zohoCustomerId || "";
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.steps = action.payload.steps || "";
      state.role = action.payload.role || "";
      state.solarStudyInvite = action.payload.solarStudyInvite || false;
      state.contactOwnerUserId = action.payload.contactOwnerUserId || "";
      state.Contact_Group = action.payload.Contact_Group || "";
      state.email = action.payload.email || "";
      state.purlDocuments = action.payload.purlDocuments || false;
      return state;
    },
  },
});

export const { setUserLogin } = loginSlice.actions;

export default loginSlice.reducer;
